export const completedProjects = [
  {
    name: "Photosnap",
    description: "A multipage marketing website for a photo sharing app. Built with a mobile-first workflow and web accessibility in mind.",
    image: "https://i.imgur.com/EpTegDF.png",
    techStack: ["React", "Sass", "Framer Motion"],
    repo: "https://github.com/kaseyvee/photosnap",
    demo: "https://kaseyvee.github.io/photosnap/"
  },
  {
    name: "Clock App",
    description: "A simple clock app built with multiple APIs to gather time, location, and quote data. Built with a mobile-first workflow to ensure the beautiful design is maintained on various devices.",
    image: "https://i.imgur.com/qEdkhND.png",
    techStack: ["Axios", "React", "Sass", "Framer Motion"],
    repo: "https://github.com/kaseyvee/clock-app",
    demo: "https://kaseyvee.github.io/clock-app/"
  },
  {
    name: "teebo",
    description: "A discourse app that caters to passionate tv fans who want to have active discussions about their favourite shows.",
    image: "https://i.imgur.com/kZwhgMa.png",
    techStack: ["Node.js", "Express", "Sass", "React", "PostgreSQL"],
    repo: "https://github.com/muhammad-usama12/teebo",
    demo: ""
  },
  {
    name: "untitled yum yum app",
    description: "An app for sharing your personal restaurant and menu item favourites for your peers.",
    image: "https://i.imgur.com/7fP0gRU.png",
    techStack: ["Next.js", "Sass", "Pocketbase"],
    repo: "https://github.com/kaseyvee/my-restaurant-list",
    demo: "https://untitled-yum-yum-app.vercel.app/"
  },
  {
    name: "me.brand()",
    description: "A fully front-end template generator for providing users a medium to introduce themselves with an eye-catching photo/banner using recognizable and iconic designs.",
    image: "https://i.imgur.com/PUEelKh.png",
    techStack: ["React", "Sass"],
    repo: "https://github.com/kaseyvee/me-brand",
    demo: "https://kaseyvee.github.io/me-brand/"
  },
  {
    name: "Manage Landing Page",
    description: "This landing page was built with a mobile-first workflow and web accessibility in mind. Web accessibility was a key consideration in the development process, making sure the landing page is inclusive and can be accessed by everyone.",
    image: "https://i.imgur.com/ap1fyaE.png",
    techStack: ["React", "Sass", "Framer Motion"],
    repo: "https://github.com/kaseyvee/manage-landing",
    demo: "https://kaseyvee.github.io/manage-landing/"
  }
];

export const inProgressProjects = [
  {
    name: "District Eleven Restaurant",
    description: "A full-stack marketing and menu website for local Vancouver restaurant, District Eleven.",
    image: "https://i.imgur.com/ofUm6R0.png",
    techStack: ["Node.js", "React", "Sass", "Contentful"],
    repo: "https://github.com/wagabooga/D11",
    demo: ""
  },
  {
    name: "AKMUO",
    description: "A front-end e-commerce application for Vancouver-based AKMUO Jewelry.",
    image: "https://i.imgur.com/Zuw9Ydb.png",
    techStack: ["React", "Sass"],
    repo: "https://github.com/kaseyvee/akmuo",
    demo: ""
  }
];